export default {
  personalInformation: {
    dayPhoneEdited: false,
    emailEdited: false,
  },
  jointContactInformation: {
    newAddressProvided: false,
    primaryUserAgreed: false,
    secondaryUserAgreed: false,
  },
};
